// extracted by mini-css-extract-plugin
module.exports = {"container":"U03a8UKFewlTR-zzJE0HfA==","msgType":"Hi1gSxzewHLcp+4Q-cIXcw==","linkBtn":"G9rgoZBAR-DwyK7RdQTP-g=="};